import ThisModule from "./ModalHeading";

export default ThisModule;
